<template>
  <section
    id="section"
    class="slideDown"
  >

    <div
      class="back"
      @click="back()"
    >{{ $t('general.return') }}</div>

    <div class="container">
      <div class="content">
        <div class="meta" :class="{'hidden': hideDetails}">
          <div class="date">
            {{ $t('views.orders.date')}}{{ order.number }} {{ formatDate(order.date) }}
            <div class="button" @click="hideDetails = !hideDetails">
              <img src="/img/icons/down.png" alt="">
            </div>
          </div>
          <div class="status" :class="['s'+current_order.status, { expanded: isSelectOpen }]">
            <img :src="'/img/icons/status-' + current_order.status + '.png'" />
            <div class="custom-select">
              <div class="selected-option" @click="toggleSelect">
                {{ $t('views.orders.status.' + current_order.status) }}
                <img src="/img/icons/down-arrow.png" class="arrow" :class="{'invert': current_order.status === '1', 'expanded': isSelectOpen}" />
              </div>
              <div class="options" v-if="isSelectOpen">
                <div 
                  v-for="option in filteredStatus" 
                  :key="option.id"
                  class="option"
                  @click="selectOption(option.id)"
                >
                  <img :src="'/img/icons/status-' + option.id + '.png'" class="option-icon" :class="{'invert': option.id === '1'}" />
                  {{ $t('views.orders.status.' + option.id) }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="item details" :class="{'hidden': hideDetails}">
          {{ $t('admin.views.order.details') }}
        </div>
        <div
          v-for="(item, index) in order.items"
          class="item"
          :key="item.id"
          :class="{'hidden': hideDetails}"
        >

          <div class="box-resume">
            <img
              class="image"
              :src="item.from.image"
            />

            <div class="container">
              <div class="title">{{ item.from.filename }}</div>
              <div class="columns"></div>
                <div class="resume">
                  <div class="column">
                  <div class="row">
                    <label class="label">{{ $t('admin.views.order.resource') }}</label>
                    <span class="value">{{ item.from.filename }}</span>
                  </div>
                  <div class="row" v-if="item.from.reference">
                    <label class="label">{{ $t('admin.views.order.reference') }}</label>
                    <span class="value">{{ item.from.reference }}</span>
                  </div>
                  <div class="row">
                    <label class="label">{{ $t('admin.views.order.link') }}</label>
                    <span class="value"><a :href="item.from.link" target="_blank">{{ $t('general.piece_abbreviation') }}</a></span>
                  </div>
                  <div class="row">
                    <label class="label">{{ $t('general.file') }}</label>
                    <span class="value"><a :href="item.custom_file" target="_blank">{{ $t('general.download') }}</a></span>
                  </div>
                </div>
                <div class="column">
                  <div class="row">
                    <label class="label">{{ $t('admin.views.order.budget') }}</label>
                    <span class="value">{{ method[item.method] }}</span>
                  </div>
                  <div class="row">
                    <label class="label">{{ $t('admin.views.order.adaptation') }}</label>
                    <span class="value" v-if="sizes[item.to.file] && sizes[item.to.file][item.to.filename]">{{ sizes[item.to.file][item.to.filename].name }}</span>
                  </div>
                  <div class="row">
                    <label class="label">{{ $t('general.format') }}</label>
                    <span class="value">{{ types[item.to.file].name.toUpperCase() }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="box-info" v-if="item.method == 2">
            <div class="image" style="width: 100px;"></div>
            <div class="container">
              <div class="units">
                <div class="row">
                  <label class="label">{{ $t('admin.views.order.units') }}</label>
                  <span class="value" v-if="item.method == 2 && item.units_scale_custom">
                    {{ item.units_scale_custom }}
                  </span>
                  <span class="value" v-else-if="item.method == 2">
                    {{ item.units_scale }}
                  </span>
                  <span class="value" v-else>
                    {{ item.units }}
                  </span>
                </div>
                <div class="row" v-if="item.custom.legal">
                  <label class="label">{{ $t('views.order.customize.legal') }}</label>
                  <span class="value">{{ item.custom.legal }}</span>
                </div>
                <div class="row">
                  <label class="label">{{ $t('admin.views.order.send_to') }}</label>
                  <span class="value">
                    <template v-if="item.method == 2">
                      <template v-if="item.custom_ship">
                        {{ item.custom_ship }}
                      </template>
                      <template v-else-if="locations && locations[item.shipped]">
                        {{locations[item.shipped].site }} - {{locations[item.shipped].name }} {{ locations[item.shipped].cif }}
                      </template>
                    </template>
                  </span>
                </div>
                <div class="row">
                  <label class="label">{{ $t('admin.views.order.project') }}</label>
                  <span class="value">
                    <template v-if="item.method == 2">
                      <template v-if="item.custom_ship">
                        {{ item.custom_ship }}
                      </template>
                      <template v-else-if="locations && locations[item.shipped]">
                        {{locations[item.shipped].site }} - {{locations[item.shipped].name }} {{ locations[item.shipped].cif }}
                      </template>
                    </template>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="box-info" :class="{'restaurant': index === Object.keys(order.items)[Object.keys(order.items).length - 1]}">
            <div class="image" style="width: 100px;"></div>
            <div class="container">
              <div class="column">
                <div class="row">
                  <label class="label">{{ $t('general.restaurant') }}</label>
                  <span class="value">
                    {{ item.custom.restaurant }}
                  </span>
                </div>
                <div class="row" v-if="item.custom.price">
                  <label class="label">{{ $t('general.price') }}</label>
                  <span class="value">
                    {{ item.custom.price }}
                  </span>
                </div>
                <div class="row" v-if="item.custom.legal">
                  <label class="label">{{ $t('views.order.customize.legal') }}</label>
                  <span class="value">
                    {{ item.custom.legal }}
                  </span>
                </div>
                <div class="row" v-if="item.custom.others">
                  <label class="label">{{ $t('admin.views.order.others') }}</label>
                  <span class="value">
                    {{ item.custom.others }}
                  </span>
                </div>
              </div>
              <div class="column" v-if="market == 'ES'">
                <div class="row">
                  <label class="label">{{ $t('admin.views.order.questions') }}</label>
                </div>
                <div class="row">
                  <label class="label">{{ $t('admin.views.order.cupouns') }}</label>
                  <span class="value">
                    {{ item.params.q1 == 1 ? $t('general.leave_confirm') : $t('general.leave_cancel') }}
                  </span>
                </div>
                <div class="row">
                  <label class="label">{{ $t('admin.views.order.trolley') }}</label>
                  <span class="value">
                    {{ item.params.q2 == 1 ? $t('general.leave_confirm') : $t('general.leave_cancel') }}
                  </span>
                </div>
              </div>
              <div class="column" v-if="market == 'PT'">
                <div class="row">
                  <label class="label">{{ $t('views.order.customize.start_date') }}</label>
                  <span class="value">
                    {{ formatDateDays(item.custom.start_date) }}
                  </span>
                </div>
                <div class="row">
                  <label class="label">{{ $t('views.order.customize.end_date') }}</label>
                  <span class="value">
                    {{ formatDateDays(item.custom.end_date) }}
                  </span>
                </div>
                <div class="row direction-row" v-if="item.custom.direction">
                  <label class="label">{{ $t('general.direction') }}</label>
                  <div class="value">
                    <img :src="item.custom.direction.image" alt="Direction" />
                    <span class="value">
                      {{ item.custom.direction.text }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="item"><label>Personalización:</label><span v-if="item.custom == null && !item.custom_file" class="value">Sin personalización</span></div>
              <div class="custom">
                <div class="item" v-if="item.custom != null && item.custom.restaurant && item.custom.restaurant != ''"><label>Restaurante:</label><span class="value">{{ item.custom.restaurant }}</span></div>
                <div class="item" v-if="item.custom != null && item.custom.price"><label>Precio:</label><span class="value">{{ item.custom.price }}</span></div>
                <div class="item" v-if="item.custom != null && item.custom.schedule"><label>Horario:</label><span class="value">{{ item.custom.schedule }}</span></div>
                <div class="item" v-if="item.custom != null && item.custom.date"><label>Fecha:</label><span class="value">{{ item.custom.date }}</span></div>
                <div class="item" v-if="item.custom_file"><label>Fichero:</label><span class="value"><a :href="item.custom_file" target="_blank">Descargar</a></span></div>
                <div class="item" v-if="item.custom != null && item.custom.others"><label>Otros:</label><span class="value">{{ item.custom.others }}</span></div>
              </div>
            </div>
            <div class="item" v-if="Object.keys( item.params ).length > 0"><label>Preguntas:</label><span class="value"></span></div>
              <div class="custom">
                <div class="item" v-if="item.params.q1">
                  <label>¿Con cupones?:</label>
                  <span v-if="item.params.q1 == 1" class="value">Sí</span>
                  <span v-if="item.params.q1 == 0" class="value">No</span>
                </div>
                <div class="item" v-if="item.params.q2">
                  <label>* ¿Quieres que estén troquelados?:</label>
                  <span v-if="item.params.q2 == 1" class="value">Sí</span>
                  <span v-if="item.params.q2 == 0" class="value">No</span>
                </div>
                <div class="item" v-if="item.params.q4">
                  <label>* ¿Con cantos redondeados?:</label>
                  <span v-if="item.params.q4 == 1" class="value">Sí</span>
                  <span v-if="item.params.q4 == 0" class="value">No</span>
                </div>
                <div class="item" v-if="item.params.q5">
                  <label>* Indica si es para revista o periódico:</label>
                  <span v-if="item.params.q5 == 1" class="value">Revista</span>
                  <span v-if="item.params.q5 == 0" class="value">Períodico</span>
                </div>
                <div class="item" v-if="item.params.q6">
                  <label>* ¿Necesitas recibir soporte?:</label>
                  <span v-if="item.params.q6 == 1" class="value">Sí</span>
                  <span v-if="item.params.q6 == 0" class="value">No</span>
                </div>
                <div class="item" v-if="item.params.q7">
                  <label>* ¿Necesitas recibir peana?:</label>
                  <span v-if="item.params.q7 == 1" class="value">Sí</span>
                  <span v-if="item.params.q7 == 0" class="value">No</span>
                </div>
                <div class="item" v-if="item.params.q8">
                  <label>* ¿Con sobres?:</label>
                  <span v-if="item.params.q8 == 1" class="value">Sí</span>
                  <span v-if="item.params.q8 == 0" class="value">No</span>
                </div>
                <div class="item" v-if="item.params.custom_file"><label>* Fichero:</label><span class="value"><a :href="item.params.custom_file" target="_blank">Descargar</a></span></div>
                <div class="item" v-if="item.params.custom"><label>* Otros:</label><span class="value">{{ item.params.custom }}</span></div>
              </div>
            </div>

          </div> -->

        </div>

        <OrderChat :order_id="order.id" :user_id="order.user_id" type="admin" />

      </div>
      <div class="contact_info">
        <div class="subtitle">{{ $t('admin.views.order.client') }}</div>
        <div class="param">{{order.contact_name}}</div>
        <div class="param">{{Object.keys(order.items).length}} {{ $t('admin.views.order.article') }}</div>
        <div class="subtitle">{{ $t('admin.views.order.order_number') }}</div>
        <div class="param">{{'#O-' + order.number}}</div>
        <div class="subtitle">{{ $t('admin.views.order.date') }}</div>
        <div class="param">{{formatDate(order.date)}}</div>
        <div class="subtitle">{{ $t('admin.views.order.client_info') }}</div>
        <div class="param email">{{order.contact_email}}</div>
        <div class="param phone">{{order.contact_phone}}</div>
        <div class="subtitle">{{ market == 'ES' ? 'Site:' : 'ID:' }}</div>
        <div class="param">{{order.restaurant_site }}</div>
        <div class="subtitle">{{ $t('general.restaurant') }}</div>
        <div class="param">{{order.restaurant_name }}</div>
        <div class="subtitle" v-if="market == 'ES'">{{ $t('admin.views.order.razon') }}</div>
        <div class="param" v-if="market == 'ES'">{{order.restaurant_razon }}</div>
      </div>
    </div>

  </section>
</template>

<script>
import OrderChat from '../order/chat.vue';

export default {
  components: {
    OrderChat
  },
  props: { order: Object },
  data () {
    return {
      status: this.$store.getters['orders/getOrderStatus'],
      sizes: this.$store.getters['orders/getSizes'],
      questions: this.$store.getters['orders/getQuestions'],
      personalization: this.$store.getters['orders/getPersonalizations'],
      description: this.$store.getters['orders/getDescriptions'],
      current_order: {},
      method: {
        '1': this.$i18n.t('general.adaptation_final'),
        '2': this.$i18n.t('general.adaptation_final_production')
      },
      isSelectOpen: false,
      hideDetails: false
    }
  },
  created () {
    this.$router.push({ name: 'orders_edit', params: { id: this.order.id } })
    this.current_order = JSON.parse(JSON.stringify(this.order))
  },
  computed: {
    locations () {
      return this.$store.getters['locations/getLocations']
    },

    types () {
      return this.$store.getters['files/getTypesCustomizable']
    },

    status_color () {
      return this.status[this.current_order.status].color
    },

    filteredStatus() {
      var status = this.status
      var currentOrder = this.current_order
      var filtered = Object.keys(status).reduce(function(r, e) {
        if (e != currentOrder.status) {
          r.push(status[e])
        }
        return r
      }, [])
      return filtered
    },
    market() {
      return this.$store.getters['getMarket'];
    }
  },
  methods: {
    back () {
      this.save();
      this.$store.commit('orders/setCurrentOrder', false)
      this.$router.push({ name: 'admin_orders' })
    },
    save () {
      var self = this
      this.$store.dispatch('orders/uploadOrder', this.current_order).then(function () {
        self.$store.commit('orders/setCurrentOrder', false)
      })
    },
    formatDate (date) {
      return moment(date).format('HH:mm DD/MM/YYYY')
    },
    toggleSelect() {
      this.isSelectOpen = !this.isSelectOpen;
    },
    selectOption(optionId) {
      this.current_order.status = optionId;
      this.isSelectOpen = false;
    },
    formatDateDays(date) {
      return moment(date).format('DD/MM/YYYY')
    }
  },
  watch: {
    current_order: {
      handler(newVal) {
        this.$store.dispatch('orders/uploadOrder', newVal);
      },
      deep: true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#file {
  max-width: 1200px;
  margin: 0 auto;
  margin-bottom: 50px;
}

.back {
  background: url(/img/left-arrow.svg) no-repeat left center;
  text-align: left;
  margin-bottom: 20px;
  padding-left: 25px;
  cursor: pointer;
}
.container {
  width: 100%;
  display: flex;
  gap: 16px;

  .contact_info {
    background-color: #FFFFFF;
    border: 1px solid #CCCCCC;
    border-radius: 4px;
    padding: 16px;
    flex-shrink: 0;
    width: auto;
    height: fit-content;

    .subtitle {
      padding-bottom: 16px;
      font-size: 14px;
      color: #2C3E50;
      font-weight: bold;
      text-align: left;
    }

    .param {
      padding-bottom: 16px;
      font-size: 14px;
      color: #999999;
      width: 100%;
      overflow: hidden;
      text-align: left;

      &.email {
        color: #005BD3; 
      }

      &.phone {
        color: #005BD3;
      }
    }
  }

  .content {
    flex: 1;
    text-align: left;
    min-width: 0;

    .meta {
      text-align: left;
      background: #ddd;
      padding: 10px;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 1px solid #CCCCCC;
      border-left: 1px solid #CCCCCC;
      border-right: 1px solid #CCCCCC;
      border-radius: 4px 4px 0px 0px;

      &.hidden {
        border-radius: 4px;
      }

      .date {
        font-family: Speedee-Bold;
        font-size: 24px;
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        font-size: 12px;
        .button {
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .status {
        display: inline-block;
        margin-left: 15px;
        background: #ccc;
        border-radius: 4px;
        padding: 8px;
        font-size: 14px;
        color: #111;
        float: right;
        display: flex;
        align-items: center;
        position: relative;
        transition: width 0.2s ease;

        &.expanded {
          width: 220px;
          background-color: #FFFFFF !important;
          color: #111111 !important;
          border-radius: 4px 4px 0 0;

        }

        img {
          height: 16px;
          width: 16px;
          margin-right: 4px;
          display: inline-block;
          vertical-align: middle;
        }

        &.s1 {
          background-color: black;
          color: white;

          > img {
            filter: invert(100%);
          }

          &.expanded > img {
            filter: none;
          }
        }

        &.s2 {
          background-color: #FFFFFF;
          color: #111111;
        }

        &.s3 {
          background-color: #ffeb3b;
          color: #111111;
        }
        
        &.s4 {
          background-color: #96d6be;
          color: #111111;
        }

        &.s5 {
          background-color: #ff9e80;
            color: #111111;
        }

        .custom-select {
          position: relative;
          display: inline-block;
          width: 100%;

          .selected-option {
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: transparent;
            color: inherit;
            font-size: 14px;
            margin-left: 4px;
            width: 100%;

            .arrow {
              width: 25px;
              height: 20px;
              margin-left: 8px;

              &.invert {
                filter: invert(100%);
              }

              &.expanded {
                display: none;
              }
            }
          }

          .options {
            position: absolute;
            z-index: 1;
            background-color: #FFFFFF;
            width: 220px;
            top: 100%;
            left: -28px;
            margin-top: 8px;
            border-radius: 0 0 4px 4px;

            .option {
              border-radius: 0 0 4px 4px;
              padding: 8px;
              cursor: pointer;
              display: flex;
              align-items: center;
              background-color: #FFFFFF;
              color: #111111;
              font-size: 14px;

              .option-icon {
                width: 16px;
                height: 16px;
                margin-right: 4px;

                &.invert {
                  filter: brightness(0);
                }
              }

              &:hover {
                background-color: #EEEEEE;
              }
            }
          }
        }
      }
    }

    .title {
      margin: 10px 0;
      font-size: 20pt;
      font-family: Speedee-Bold;
    }
    .details {
      font-size: 12px;
      padding: 8px 8px !important;
      text-transform: uppercase;
      transition: all 0.6s ease;
      max-height: 1000px;
      opacity: 1;
      border-radius: 0px !important;

      &.hidden {
        max-height: 0;
        opacity: 0;
        padding: 0;
        margin: 0;
      }

      .subtitle {
        font-family: Speedee-Bold;
        color: #bbb;
        margin-bottom: 10px;
      }
      .item {
        font-size: 11pt;

        .label {
          margin-right: 5px;
        }
        .value {
          font-family: Speedee-Bold;
        }
      }
    }
    .custom {
      padding-left: 20px;
      font-size: 12px;
    }

    .item {
      width: 100%;
      display: block;
      overflow: hidden;
      text-align: left;
      padding: 0;
      background-color: #FFFFFF;
      transition: all 0.6s ease;
      max-height: 1000px;
      opacity: 1;
      border-left: 1px solid #CCCCCC;
      border-right: 1px solid #CCCCCC;
      border-radius: 0px 0px 4px 4px;

      &.hidden {
        max-height: 0;
        opacity: 0;
        padding: 0;
        margin: 0;
      }

      .box-resume {
        padding: 15px 25px;
        width: 100%;
        display: block;
        float: left;

        .image {
          width: 100px;
          float: left;
          padding: 5px;
        }
        .container {
          width: calc(100% - 100px);
          float: left;
          padding: 0px 15px;
          display: flex;
          flex-direction: column;
          gap: 0px;

          .title {
            width: 100%;
            font-size: 12px !important;
            font-weight: bold;
            color: #2C3E50;
          }

          .resume {
            display: flex;
            flex-direction: row;
            width: 100%;
            text-align: left;
            gap: 16px;

            .column {
              flex: 1;
              display: flex;
              flex-direction: column;
              gap: 8px;
            }

            .row {
              display: flex;
              align-items: flex-start;
              gap: 8px;

              .label {
                min-width: 120px;
                color: #666;
                padding-top: 2px;
              }
              .value {
                flex: 1;
                word-break: break-word;
              }
            }
          }
        }
      }

      .box-info {
        padding: 15px 25px;
        width: 100%;
        display: block;
        float: left;
        border-top: 1px solid #CCCCCC;
        /* border-left: 1px solid #CCCCCC;
        border-right: 1px solid #CCCCCC; */
        &.restaurant {
          border-bottom: 1px solid #CCCCCC !important;
          border-radius: 0px 0px 4px 4px;
        }

        .image {
          width: 100px;
          float: left;
          padding: 5px;
        }

        .container {
          width: calc(100% - 100px);
          float: left;
          padding: 0px 15px;
          display: flex;
          gap: 16px;

          .units {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .column {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 8px;
          }
        }

        .row {
          display: flex;
          align-items: flex-start;
          gap: 8px;

          .label {
            min-width: 120px;
            color: #666;
            padding-top: 2px;
          }
          .value {
            flex: 1;
            word-break: break-word;
          }

          &.direction-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 4px;

            .label {
              min-width: auto;
            }

            .value {
              display: flex;
              align-items: center;
              gap: 8px;
            }
          }
        }
      }
    }

    .buttons {
      margin: 35px 0;

      .bttn {
        width: 100%;
        max-width: 300px;
        overflow: hidden;
        margin-bottom: 5px;
        line-height: 30px;
        cursor: pointer;
        display: block;
        color: #333;

        .icon {
          width: 30px;
          height: 30px;
          background: #ccc;
          display: inline-block;
          float: left;
          overflow: hidden;
        }
        span {
          display: inline-block;
          float: left;
          padding-left: 5px;
          font-size: 11pt;

          &:hover {
            font-family: Speedee-Bold;
          }
        }
        &.download {
          border-top: 2px solid var(--main_color);

          .icon {
            background: url(/img/download.svg) no-repeat center
              var(--main_color);
            background-size: 18px;
          }
        }
        &.order {
          border-top: 2px solid #ccc;
          .icon {
            background: url(/img/edit.svg) no-repeat center #ccc;
            background-size: 18px;
          }
        }
      }
    }
    .desc {
      font-size: 10pt;
      margin-top: 25px;
      margin-bottom: 5px;
      display: block;
    }
    .url {
      width: 100%;
      padding: 5px;
      font-size: 11pt;
      border-radius: 5px;
      border: 1px solid #ccc;
    }
  }
}
</style>
